// Installed modules
import Vue from 'vue'
import Buefy from 'buefy'
import LoremIpsum from 'vue-lorem-ipsum'
import { MDXProvider } from '@mdx-js/vue'
import VueCompositionApi from '@vue/composition-api'
import consola from 'consola'

// Local modules
import './registerServiceWorker'
import registerIcons from './plugins/fa'
import Sentry from './plugins/sentry'
import router from './router'
import store from './store'
import MDXComponents from './components/mdx/components'
import PhanerooNotifications from './plugins/breadstick'
import './scss/_tailwind.scss'
import './scss/_all.scss'

// Global components
import App from './App.vue'
import AuthProvider from './components/auth-provider'
import Dashboard from './layouts/dashboard'
import Default from './layouts/default'
import Docs from './layouts/docs'

// Production devtools config
Vue.config.productionTip = false

// Register sentry
Vue.use(Sentry)

// Icons
registerIcons(Vue)

// Globally register layouts
Vue.component('default-layout', Default)
Vue.component('dashboard-layout', Dashboard)
Vue.component('docs-layout', Docs)
Vue.component('lorem', LoremIpsum)

Vue.use(VueCompositionApi)
Vue.use(PhanerooNotifications)

Vue.use(Buefy, {
  css: false,
  materialDesignIcons: false,
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas'
})

// Register logger globally
Vue.prototype.$logger = consola

new Vue({
  router,
  store,
  render: h => h(MDXProvider, {
    props: {
      components: MDXComponents
    }
  }, [
    h(AuthProvider, [
      h(App)
    ])
  ])
}).$mount('#app')
